/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Email_Code_ResendInputs */

const de_auth_mfa_email_code_resend = /** @type {(inputs: Auth_Mfa_Email_Code_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code erneut senden`)
};

/** @type {(inputs: Auth_Mfa_Email_Code_ResendInputs) => LocalizedString} */
const en_auth_mfa_email_code_resend = de_auth_mfa_email_code_resend;

/**

* @param {Auth_Mfa_Email_Code_ResendInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_email_code_resend = /** @type {((inputs?: Auth_Mfa_Email_Code_ResendInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Email_Code_ResendInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_email_code_resend(inputs)
	return en_auth_mfa_email_code_resend(inputs)
});